import { Navigate, useSearchParams } from "react-router";
import { AdminLoginForm } from "@/components/auth/admin-login-form";
import { useSession } from "@shared/client/session";
import { usePageTitle } from "@shared/client/view";
import { safeNext } from "@shared/lib/auth-shared";
import { APP_URL } from "@shared/lib/hosts";

export default function AdminLoginPage() {
  usePageTitle("Connexion — Administration Hune");
  const [params] = useSearchParams();
  const session = useSession();
  const target = safeNext(params.get("next"), "/admin");
  if (session === undefined) return null;
  if (session?.isAdmin) return <Navigate replace to={target} />;

  return (
    <main className="grid min-h-screen place-items-center bg-background px-4">
      {/* Connecté mais sans droit d'admin : on le dit plutôt que de boucler. */}
      <AdminLoginForm appUrl={APP_URL} deniedEmail={session?.user.email ?? null} next={target} />
    </main>
  );
}
